import axios from 'axios';
import c from './course-helper';
import expand from './expand';
import select from './select';
import cart from '../components/cart';
import { $, endPoint, findTarget, dataExist, loading } from '../utils/Utils';

const courseFinder = (() => {
  const triggers = [...$('.js-courseFinder')];
  const targetCN = 'js-courseFinderTarget';
  const parent = 'js-courseFinderParent';

  const handleIfItemIsBundle = ({ trigger, data, inputs }) => {
    if (trigger.dataset.bundle) {
      // get the value of the input
      const val = parseFloat(trigger.value);

      // get the IDs of the courses included in the bundle
      const IDs = data
        .filter(item => item.id === val)[0].bundle
        .map(course => course.id);

      // check if we have courses included
      if (IDs.length > 0 && IDs) {
        // targets are the *inputs* of the courses included in the bundle
        let targets = IDs
          .map(id => inputs.filter(input => parseFloat(input.value) === id)[0])
          .filter(target => (!!(target)));

        // we need to get the items in the cart
        let arr = cart.get();

        // is the input being checked or unchecked?
        if (trigger.checked) {
          // disable course included in the bundle
          targets.forEach((input) => {
            input.setAttribute('disabled', 'disabled');
            input.checked = false;
          });

          // udpate cookies by removing the included courses and adding the bundle number instead
          if (arr.length > 0) {
            IDs.map(id => {
              arr = arr.filter(item => item !== id);
            });
          }

          cart.update(arr);
        } else {
          // remove 'disable' on courses included in the bundle
          // unless they are already in another bundle that is also checked
          // let's gather all the other bundles except the one unchecked (trigger)
          const otherBundlesIncart = c
            .get()
            .filter(course => course.id !== val)
          // and check if any of them are in the cart
            .filter(course => arr.indexOf(course.id) > -1);

          if (otherBundlesIncart.length > 0) {
            // Ok it seems like there're bundle in the cart
            // that have similar courses in their package as trigger
            // remove them from the array of targets
            // so they are not affected by the removal of the 'disable' attribute
            const removeFromTargets = [];
            otherBundlesIncart.forEach((item) => {
              item.bundle.map((course) => {
                if (IDs.indexOf(course) > -1 && removeFromTargets.indexOf(course) < 0) {
                  removeFromTargets.push(course);
                }
              });
            });
            targets = targets.filter(input => removeFromTargets.indexOf(parseFloat(input.value)) < 0);
          }

          targets.forEach((input) => {
            input.removeAttribute('disabled');
          });
        }
      }
    }
  };

  const handleCartUpdate = (data) => {
    const inputs = [...$('.js-updateCart')];
    // listen for all checkboxes
    inputs.forEach((trigger) => {
      trigger.addEventListener('change', () => {
        // we must check if the input is a bundle
        handleIfItemIsBundle({ data, trigger, inputs });
        // update the cart with the change
        cart.add(trigger);
      });
    });
  };

  const createMarkup = courses => courses.map((course, i) => `
    <li class="listCourses__listItem" style="animation-delay: ${i * 200}ms;">
      <article class="course ${(!('bundle' in course)) ? '' : '-bundle'}">
        <label for="c-${i}" class="checkbox">
          ${(dataExist(course, 'id')) ? `
          <input class="js-updateCart" type="checkbox" id="c-${i}" value="${course.id}"
            ${(dataExist(course, 'bundle')) ? 'data-bundle="true"' : ''}
            ${(cart.hasBundle(course.id)) ? 'disabled' : `${(cart.hasItem(course.id)) ? 'checked' : ''}`}
          >` : ''}
          <span class="checkbox__label">&nbsp;</span>
        </label>
        <div class="js-expandParent">
          <h1 class="h2"><label for="c-${i}">${(dataExist(course, 'name')) ? `${course.name}` : '&nbsp;'}</label></h1>
          <ul class="course__details">
            <li>${(dataExist(course, 'campaign')) ? `<ins class="price -campaign">${course.campaign.plainPrice} kr</ins><del class="price -regular">${course.plainPrice} kr</del>` : `${course.plainPrice} kr`}</li>
            <li>${(dataExist(course, 'bundle')) ? `${course.bundle.length} kurser` : `Längd: ${course.duration} min`}</li>
            ${(dataExist(course, 'bundle') || dataExist(course, 'description')) ? `
            <li>
              <span class="js-expandTrigger link" data-expand="- Läs mindre" data-compact="${(dataExist(course, 'bundle')) ? 'Läs vilka kurser som ingår">Läs vilka kurser som ingår' : '+ Läs mer">+ Läs mer'}</span>
            </li>
          </ul>
          <div class="course__information js-expandTarget -active">
            <h2 class="title">Information</h2>
            <p>${(dataExist(course, 'bundle')) ? `${course.bundle.map(item => `${item.name}, `).join('')}` : `${course.description}`}</p>
          </div>` : '</ul>'}
        </div>
      </article>
    </li>`).join('');

  const handleMarkup = ({ data, target }) => {
    target.innerHTML = createMarkup(data);

    // allow user to click on Read more and see more info
    expand.init();

    handleCartUpdate(data);
  };

  const handleChange = (trigger) => {
    const route = `${endPoint.category}${select.getValue(trigger)}`;
    const target = findTarget({ element: trigger, parent, target: targetCN });

    loading.show(target);

    // get list of courses/bundles from API
    // for the selected option in the <select>
    axios
      .get(route)
      .then((response) => {
        loading.stop(target);

        if (response.data) {
          handleMarkup({ target, data: response.data });
        }
      });
  };

  const build = () => {
    // we need to know which courses are included in a bundle
    c.handleBundles();

    triggers.forEach((trigger) => {
      // get the actual category first
      handleChange(trigger);

      // then watch any changes
      trigger.addEventListener('change', () => handleChange(trigger));
    });
  };

  const init = () => {
    if (triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default courseFinder.init();



// WEBPACK FOOTER //
// ./components/course-finder.js